<template>
  <ContextMenu v-if="locales && brandconfig.lang?.length > 1" @update:open="isOpen = $event">
    <ContextMenuButtonTrigger v-bind="$attrs">
      <button
        type="button"
        class="flex gap-1 items-center whitespace-nowrap h-11"
        aria-haspopup="menu"
        :aria-expanded="isOpen"
        :aria-label="`${$t('Language')}: ${langCode}`">
        <!-- The same globe as the supplier portal's language menu. -->
        <LanguageIcon class="size-5 flex-none" aria-hidden="true" />
        <span class="text-sm font-medium">{{ langCode }}</span>
        <ChevronDownIcon class="size-3 flex-none transition-transform" :class="isOpen && 'rotate-180'" />
      </button>
    </ContextMenuButtonTrigger>

    <ContextMenuContent class="min-w-56" :aria-label="$t('Language')">
      <ContextMenuLabel>{{ $t("Language") }}</ContextMenuLabel>
      <!-- One of a set, so menuitemradio: only that role may carry aria-checked. -->
      <ContextMenuButton
        v-for="option of locales"
        :key="option"
        role="menuitemradio"
        class="justify-between gap-6"
        :class="locale === option && 'bg-surface-selected'"
        :aria-checked="locale === option"
        @select="switchLocale(option)">
        <span class="flex items-center gap-2">
          {{ LOCALES[option]?.title }}
        </span>
        <CheckIcon v-if="locale === option" class="size-5 flex-none" aria-hidden="true" />
      </ContextMenuButton>
    </ContextMenuContent>
  </ContextMenu>
</template>

<script setup>
import { ref } from "vue";
import { CheckIcon } from "@heroicons/vue/24/outline";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import {
  ContextMenu,
  ContextMenuButton,
  ContextMenuButtonTrigger,
  ContextMenuContent,
  ContextMenuLabel,
} from "@xs2event/js-lib/components";
import brandconfig from "@/brandconfig";
import { LOCALES, locales } from "./locales.js";
import { LanguageIcon } from "@xs2event/js-lib/icons";
import { useLanguageSwitch } from "./useLanguageSwitch";

// Attributes (a class, a click listener) go to the trigger: the menu itself renders no root element.
defineOptions({ inheritAttrs: false });

const isOpen = ref(false);

const { locale, langCode, switchLocale } = useLanguageSwitch();
</script>
